<template>
    <div>
        <div class="form-group">
            <label :for="'frm_range_start_at' + id">
              {{ $t('Start at') }}
              <Required v-if="required" />
            </label>
            <Datetime v-model="start"
                      :id="'frm_range_start_at' + id"
                      :min-datetime="minStartDate"
                      :max-datetime="maxStartDate"
                      :minute-step="15"
                      :timezone="zone"
                      with-timezone
                      type="datetime"></Datetime>
        </div>

        <div class="form-group">
            <label :for="'frm_range_duration_' + id">
              {{ $t('Duration') }}
              <Required v-if="required && !showEnd" />
            </label>
            <select :id="'frm_range_duration_' + id" v-model="addHourToEnd" class="form-control" :disabled="showEnd || !start">
                <option value="0"></option>
                <option value="1">1h</option>
                <option value="2">2h</option>
                <option value="4">4h</option>
                <option value="8">8h</option>
                <option value="24">24h</option>
            </select>
        </div>
        <div class="form-check form-group">
          <input type="checkbox" class="form-check-input" :id="'custom_duration_' + id" value="1" v-model="showEnd">
          <label class="form-check-label" :for="'custom_duration_' + id">
            {{ $t('Custom duration') }}
          </label>
        </div>
        <div class="form-group" v-if="!showEnd && formatedEndDatetime">
          {{ $t('End at:') }} {{ formatedEndDatetime }}
        </div>
        <div class="form-group" v-show="showEnd">
            <label :for="'frm_range_end_at' + id">
              {{ $t('End at') }}
              <Required v-if="required" />
            </label>
            <Datetime v-model="endInput"
                      :id="'frm_range_end_at' + id"
                      :min-datetime="minEndDate"
                      :max-datetime="maxEndDate"
                      :minute-step="15"
                      :timezone="zone"
                      with-timezone
                      type="datetime"></Datetime>
        </div>

        <input type="hidden" :name="startField" v-bind:value="formatedStartField">
        <input type="hidden" :name="endField" v-bind:value="formatedEndField">
    </div>
</template>

<script>
    import Datetime from "@/components/ui/Datetime.vue";
    import dayjs from "dayjs";
    import Required from "@/components/ui/Required.vue";
    export default{
      components: {
        Required,
        Datetime
      },
        props: {
            zone: {
                default: 'UTC'
            },
            minDate: {
                default: ''
            },
            maxDate: {
                default: ''
            },
            startDate : {
                default: ''
            },
            endDate : {
                default: ''
            },
            startField : {
                default: "start"
            },
            endField : {
                default: "end"
            },
            defaultRange: {
                default: 1
            },
            required: {
              type: Boolean,
              default: false
            }
        },
        data: function(){
            return {
                id: null,
                start : '',
                endInput: '',
                end : '',
                addHourToEnd: 0,
                showEnd: false,
            }
        },
        watch: {
            start: function (value) {
                this.emitChange();
                this.updateEndWithDuration();
            },
            endInput: function(value) {
                this.updateEndFromEndInput(value);
            },
            startDate (newValue) {
                this.start = newValue ? dayjs.tz(newValue, 'UTC') : null;
            },
            endDate (newValue) {
                this.end = newValue ? dayjs.tz(newValue, 'UTC') : null;
            },
            addHourToEnd: function() {
                this.updateEndWithDuration()
            },
            showEnd: function(value) {
                if (value) {
                    this.endInput = dayjs(this.end).isValid() ? dayjs(this.end).toDate() : '';
                } else {
                    this.endInput = '';
                    this.updateEndWithDuration();
                }
            },
        },
        computed: {
            minStartDate: function(){
                return this.minDate;
            },
            maxStartDate: function(){
                return this.endInput ?  this.endInput : this.maxDate;
            },
            minEndDate: function(){
                return this.start ? this.start : this.minDate;
            },
            maxEndDate: function(){
                return this.maxDate;
            },
            formatedEndDatetime: function () {
                if(this.end && dayjs(this.end).isValid()) {
                    return dayjs(this.end).tz(this.zone).format('LLL');
                } else {
                    return null
                }
            },
            formatedStartField: function() {
              if (this.start && dayjs(this.start).isValid()) {
                return dayjs(this.start).second(0).millisecond(0).utc().format()
              }
              return ''
            },
            formatedEndField: function() {
              if (this.end && dayjs(this.end).isValid()) {
                return dayjs(this.end).second(0).millisecond(0).utc().format()
              }
              return ''
            },
        },

        methods: {
            updateEndFromEndInput(value) {
                // console.log('updateEndFromEndInput');
                if (value && dayjs(value).isValid()){
                    let end = dayjs(value).clone();
                    this.setEnd(end);
                }
            },
            updateEndWithDuration() {
                // console.log('updateEndWithDuration', this.addHourToEnd, this.start, this.endInput);
                if (this.start && !this.endInput) {
                    let end = dayjs(this.start).add(parseInt(this.addHourToEnd), 'hour');
                    this.setEnd(end);
                }
            },
            setEnd(endFromStartDate) {
              if (dayjs(endFromStartDate).isValid() && dayjs(endFromStartDate).isAfter(this.endInput)) {
                this.end = this.endInput.toDate();
              } else {
                this.end = dayjs(endFromStartDate).toDate();
              }
              this.emitChange();
            },
            emitChange(){
                this.$emit('range-change', {
                    start: dayjs(this.start).isValid() ? dayjs(this.start).second(0).millisecond(0).utc().format() : '',
                    end: dayjs(this.end).isValid() ? dayjs(this.end).second(0).millisecond(0).utc().format() : '',
                });
            },
        },
        mounted: function() {
          this.id = this._uid
          this.start = this.startDate ? dayjs.utc(this.startDate) : null
          this.end = this.endDate ? dayjs.utc(this.endDate) : null;
          if(this.endDate) {
              this.endInput = dayjs.utc(this.endDate);
              this.showEnd = true;
          } else {
              this.addHourToEnd = this.defaultRange;
          }
        }
    }
</script>

<style scoped>

</style>